
import type { ExpandType } from "@mcwd/typescript-type-guards";
type ValuePossiblyEmpty<TValue> =
  [ Extract<TValue, null> | Extract<TValue, undefined> | Extract<TValue, string> ] extends [ never ]
  ? false
  : true;

type ValuesOf<T> = T[ keyof T ];

export type GetPossiblyEmptyKeys<T extends object> = ValuesOf<{
  [ K in keyof T as ([ ValuePossiblyEmpty<T[ K ]> ] extends [ true ] ? K : never) ]: K
}>;

export type GetNonEmptyKeys<T extends object> = ValuesOf<{
  [ K in keyof T as ([ ValuePossiblyEmpty<T[ K ]> ] extends [ false ] ? K : never) ]: K
}>;


type _RemoveEmptyProperties<
  T extends object,
  TPossibleEmptyKeys extends keyof T = GetPossiblyEmptyKeys<T>,
  TNonEmptyKeys extends keyof T = GetNonEmptyKeys<T>
> = ExpandType<
  { [ K in TPossibleEmptyKeys ]?: Exclude<T[ K ], null | undefined | ''> } &
  Pick<T, TNonEmptyKeys>
>;

export type RemoveEmptyProperties<T extends object> = _RemoveEmptyProperties<T>

export function removeEmptyProperties<T extends object> (obj: T): RemoveEmptyProperties<T>
{
  return Object.fromEntries(
    Object.entries(obj).filter(([ _key, value ]) => value != null && value !== '')
  ) as RemoveEmptyProperties<T>;
}

export function deleteEmptyProperties<T extends object> (obj: T): RemoveEmptyProperties<T>
{
  const allProps = (Object.keys(obj) as (keyof T)[]);

  for (const prop of allProps)
  {
    if (obj[ prop ] == null || obj[ prop ] === "")
    {
      delete obj[ prop ];
    }
  }
  return obj as unknown as RemoveEmptyProperties<T>;
}